<template src="./employees-with-pending-fees.html"></template>
<script type="text/javascript" src="https://js.iugu.com/v2"></script>
<script>
// import moment from "moment";
import { useStore } from "@/store/store.js"

import mixins from "../../../../mixins/mixins.js";

// https://www.npmjs.com/package/vue-button-spinner
import ButtonSpinner from "vue-button-spinner";

export default {
  mixins: [mixins],
  components: {
    ButtonSpinner,
  },
  data() {
    return {
      statusMessage: "",
      isLoading: false,
      status: "",
      employees: [],
      company: null,
      disabledButtonPayTax: true,
      newTaxCard: null,
      checkboxBankSlip: false,
      checkboxCreditCard: false,
      popupAlertPayTaxContent: {},
      uploadRegisters: {},
      validations: {},
      popupAlertPayTax: false,
      selected: [],
      currentx: 1,
      numPages: 0,
      windowWidth: 0,
      pagination: false,
      sortBy: "id",
      order: "desc",
      searchCompanies: "",
      csvHistoric: {},
      historicCsv: [],
      expirationMonth: null,
      expirationYear: null,
      cvcCreditCard: null,
      creditCardNumber: null,
      printedName: null,
      invalidFieldsPayTax: {
        name: false,
        nameCompany: false,
        cnpj: false,
        email: false,
        zipcode: false,
        street: false,
        number: false,
        creditCardNumber: false,
        cvcNumber: false,
        expirationMonth: false,
        expirationYear: false,
        time: false,
      },
      months: [
        { name: "Janeiro", value: 1 },
        { name: "Fevereiro", value: 2 },
        { name: "Março", value: 3 },
        { name: "Abril", value: 4 },
        { name: "Maio", value: 5 },
        { name: "Junho", value: 6 },
        { name: "Julho", value: 7 },
        { name: "Agosto", value: 8 },
        { name: "Setembro", value: 9 },
        { name: "Outubro", value: 10 },
        { name: "Novembro", value: 11 },
        { name: "Dezembro", value: 12 },
      ],
      time: [
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
        { text: "9", value: 9 },
        { text: "10", value: 10 },
      ],
      timeSelected: null,
      years: [
        { year: "2020" },
        { year: "2021" },
        { year: "2022" },
        { year: "2023" },
        { year: "2024" },
        { year: "2025" },
        { year: "2026" },
        { year: "2027" },
        { year: "2028" },
        { year: "2029" },
        { year: "2030" },
        { year: "2031" },
        { year: "2032" },
        { year: "2033" },
        { year: "2034" },
        { year: "2035" },
        { year: "2036" },
        { year: "2037" },
        { year: "2038" },
        { year: "2039" },
        { year: "2040" },
        { year: "2041" },
        { year: "2042" },
        { year: "2043" },
        { year: "2044" },
        { year: "2045" },
        { year: "2046" },
        { year: "2047" },
        { year: "2048" },
        { year: "2049" },
        { year: "2050" },
      ],
      taxCard: null,
      taxBankSlip: null,
    };
  },
  watch: {
    checkboxBankSlip: function (newVal) {
      let vm = this;
      if (newVal == true) {
        vm.checkboxCreditCard = false;
        vm.printedName = null;
        vm.creditCardNumber = null;
        vm.cvcNumber = null;
        vm.expiringMonth = null;
        vm.expiringYear = null;
      }
    },
    checkboxCreditCard: function (newVal) {
      let vm = this;
      if (newVal == true) {
        vm.checkboxBankSlip = false;
      }
    },
    selected: function () {
      let vm = this;
      vm.disabledButtonPayTax = false;
    },
    printedName: function (newVal){
      const vm = this;
      if(vm.testNullUndefinedEmpty(newVal) == false){
        vm.invalidFieldsPayTax.printedName = false;
      }
    },
    creditCardNumber: function (newVal){
      const vm = this;
      if(vm.testNullUndefinedEmpty(newVal) == false){
        vm.invalidFieldsPayTax.creditCardNumber = false;
      }
    },
    cvcCreditCard: function (newVal){
      const vm = this;
      if(vm.testNullUndefinedEmpty(newVal) == false){
        vm.invalidFieldsPayTax.cvcNumber = false;
      }
    },
    expirationMonth: function (newVal){
      const vm = this;
      if(vm.testNullUndefinedEmpty(newVal) == false){
        vm.invalidFieldsPayTax.expirationMonth = false;
      }
    },
    expirationYear: function (newVal){
      const vm = this;
      if(vm.testNullUndefinedEmpty(newVal) == false){
        vm.invalidFieldsPayTax.expirationYear = false;
      }
    },
    timeSelected: function (newVal){
      const vm = this;
      if(vm.testNullUndefinedEmpty(newVal) == false){
        vm.invalidFieldsPayTax.time = false;
      }
    },
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  setup () {
    const store = useStore()

    return {
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  mounted: function () {
    let vm = this;
    vm.init();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  methods: {
    init() {
      let vm = this;
      if (vm.testNullUndefinedEmpty(vm.$session.get("company")) === false) {
        vm.company = vm.$session.get("company");
        console.log({ company: vm.company });
      }
      vm.getNewTaxCard();
      vm.getTaxCard();
      vm.getTaxBankSlip();
    },
    clearButtonLoading() {
      setTimeout(() => {
        this.isLoading = false;
        this.statusMessage = "";
        this.status = "";
      }, 1600);
    },
    getEmployees() {
      let vm = this;
      let page = 0;
      if (vm.currentx == 1) {
        page = 0;
      } else {
        if (vm.currentx > 1) {
          page = vm.currentx - 1;
        }
      }
      vm.$vs.loading();
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "company/employees/needs-pay-tax?page=" +
            page +
            "&search=" +
            vm.searchCompanies +
            "&size=10&sort=" +
            vm.sortBy +
            "," +
            vm.order,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.employees = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            for (let e in vm.employees) {
              if (vm.testNullUndefinedEmpty(vm.newTaxCard) === false) {
                vm.employees[e].taxText = vm.maskMoney(vm.newTaxCard);
                vm.employees[e].tax = vm.newTaxCard;
              }
            }
            vm.$vs.loading.close();
          }
        })
        .catch(function (error) {
          vm.$vs.loading.close();
          console.log({ error: error });
        });
    },
    getNewTaxCard() {
      let vm = this;
      vm.$vs.loading();
      vm.axios
        .get(vm.$store.state.filooServer + "parameters/new-card-tax", {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.newTaxCard = response.data.parameter;
            vm.getEmployees();
            vm.$vs.loading.close();
          }
        })
        .catch(function (error) {
          vm.$vs.loading.close();
          console.log({ error: error });
        });
    },
    payTax() {
      let vm = this;
      vm.$vs.loading();
      let employeesId = [];
      employeesId = vm.selected.map(function (elem) {
        return { id: elem.id };
      });

      let valueTotal = vm.selected.reduce(function (total, elem) {
        return total + elem.tax;
      }, 0);
      vm.selected = [];
      let requesPayload = {
        employees: employeesId,
        type: "REGISTER_TAX",
        valueTotal: valueTotal,
      };
      vm.axios
        .post(
          vm.$store.state.filooServer + "company/employees/charge",
          requesPayload,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.popupAlertPayTaxContent = response.data;
            vm.companyUploadRegisters();
          }
        })
        .catch(function (error) {
          vm.$vs.loading.close();
          console.log({ error: error });
          vm.showNotifyWarning("Não foi possível realizar esta operação. Pois o pagamento da taxa é aplicado apenas para funcionários ativos. Refaça a seleção e tente novamente, caso o problema persista por favor contacte o administrador do sistema.", 6000);
        });
    },
    companyUploadRegisters() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "company/upload-registers/" +
            vm.popupAlertPayTaxContent.id,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.uploadRegisters = response.data;
            vm.$bvModal.show("modal-confirm-credit-recharge");
            vm.$vs.loading.close();
          }
        })
        .catch(function (error) {
          vm.$vs.loading.close();
          console.log({ error: error });
        });
    },
    confirmOperation() {
      const vm = this;
      vm.$bvModal.hide("modal-confirm-credit-recharge");
      vm.$vs.loading();
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "payment/upload-register/" +
            vm.popupAlertPayTaxContent.id +
            "/validations",
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.validations = response.data;
            vm.$vs.loading.close();
            vm.$bvModal.show("modal-payment-recharge");
          }
        })
        .catch(function (error) {
          vm.$vs.loading.close();
          console.log({ error: error });
        });
    },
    validateFieldsPayTax() {
      let vm = this;
      let valid = true;
      vm.isLoading = true;
      if (vm.checkboxBankSlip == false && vm.checkboxCreditCard == false) {
        setTimeout(() => {
         vm.isLoading = false; 
        }, 2000);
        vm.showNotifyWarning("Selecione uma forma de pagamento", 3500);
      } else {
        if (vm.checkboxCreditCard == true) {
          if (vm.validateCreditCardNumber(vm.creditCardNumber) == false) {
            vm.invalidFieldsPayTax.creditCardNumber = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.printedName)) {
            vm.invalidFieldsPayTax.printedName = true;
            valid = false;
          } else if (vm.testFullName(vm.printedName) == false) {
            vm.invalidFieldsPayTax.printedName = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.cvcCreditCard)) {
            vm.invalidFieldsPayTax.cvcNumber = true;
            valid = false;
          } else if (vm.cvcCreditCard.length < 3) {
            vm.invalidFieldsPayTax.cvcNumber = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.expirationMonth)) {
            vm.invalidFieldsPayTax.expirationMonth = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.expirationYear)) {
            vm.invalidFieldsPayTax.expirationYear = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.timeSelected)) {
            vm.invalidFieldsPayTax.time = true;
            valid = false;
          }
        }
        if (vm.checkboxBankSlip == true) {
          if (vm.testNullUndefinedEmpty(vm.company.name)) {
            vm.invalidFieldsPayTax.nameCompany = true;
            valid = false;
          }
          if (vm.validateCNPJ(vm.company.cnpj) == false) {
            vm.invalidFieldsPayTax.cnpj = true;
            valid = false;
          }
          if (vm.validateEmail(vm.company.email) == false) {
            vm.invalidFieldsPayTax.email = true;
            valid = false;
          }
          if (/^[0-9]{5}-[0-9]{3}$/.test(vm.company.address.zipcode) == false) {
            vm.invalidFieldsPayTax.zipcode = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.company.address.street)) {
            vm.invalidFieldsPayTax.street = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.company.address.number)) {
            vm.invalidFieldsPayTax.number = true;
            valid = false;
          }
        }
      }
      if (valid === true) {
        if (vm.checkboxBankSlip == true) {
          vm.finalizeBankSlipPayament();
        } else if (vm.checkboxCreditCard == true) {
          vm.initIUGUProcess();
        }
      } else {
        vm.isLoading = false;
      }
    },
    finalizeBankSlipPayament() {
      let vm = this;
      vm.isLoading = true;
      let requesPayload = {
        description: "TAX_NEW_CARD",
        method: "bank_slip",
        email: vm.company.email,
        payer: {
          name: vm.company.name,
          cpf_cnpj: vm.company.cnpj.replace(/[^\d]+/g, ""),
          address: vm.company.address,
        },
        upload_register_id: vm.popupAlertPayTaxContent.id,
      };
      vm.axios
        .post(vm.$store.state.filooServer + "payment/charge", requesPayload, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            let url = response.data.invoice_url_pdf;
            vm.clearButtonLoading();
            window.open(url, "_blank");
            vm.$bvModal.hide("modal-payment-recharge");
            vm.showNotifySuccess("Operação realizada","Boleto gerado com sucesso, o prazo para compensação do boleto é de até 3 dias úteis.", 4000 );
            vm.$router.push("/employee-payment-report");
            
          }
        })
        .catch(function (error) {
          console.log({ error: error });
          vm.clearButtonLoading();
          vm.$bvModal.hide("modal-payment-recharge");
          vm.showNotifyError("Não foi possível realizar esta operação", 6000);
        });
    },
    initIUGUProcess() {
      let vm = this;
      vm.isLoading = true;
      let creditCardNumber = vm.creditCardNumber.replace(/[^\d]+/g, "");

      let nameArray = vm.printedName.split(" ");
      let firstName = nameArray[0];
      nameArray.splice(0, 1);
      let lastName = nameArray.join(" ");
      vm.initIUGU();
      Iugu.CreditCard();

      let iuguCreditCard = Iugu.CreditCard(
        creditCardNumber,
        vm.expirationMonth.value.toString(),
        vm.expirationYear.year.toString(),
        firstName,
        lastName,
        vm.cvcCreditCard
      );

      console.log({ iuguCreditCard: iuguCreditCard });
      if (iuguCreditCard.valid()) {
        console.log("CARTAO DE CREDITO VALIDO");
        Iugu.createPaymentToken(iuguCreditCard.toData(), function (response) {
          console.log({
            method: "finalizeCreditCardPayment",
            response: response,
          });
          if (response && response.id) {
            vm.finalizeCreditCardPayment(response.id);
          } else {
            console.log("Erro ao criar token IUGU");
            setTimeout(() => {
              this.isLoading = true;
              this.statusMessage =
                "Erro ao validar cartão! Gostaria de utilizar outro cartão ou pagar com boleto?";
              this.status = "";
              this.$vs.notify({
                title: "Atenção!",
                text:
                  "Erro ao validar cartão! Gostaria de utilizar outro cartão ou pagar com boleto?",
                color: "danger",
                time: 8500,
                position: "top-right",
              });
            }, 1300);
            setTimeout(() => {
              vm.clearButtonLoading();
            }, 1300);
          }
        });
      } else {
        console.log("CARTAO DE CREDITO INVALIDO");
        setTimeout(() => {
          this.isLoading = true;
          this.statusMessage =
            "Cartão de crédito inválido insira um cartão válido e tente novamente.";
          this.status = "";
          this.$vs.notify({
            title: "Atenção!",
            text:
              "Cartão de crédito inválido insira um cartão válido e tente novamente.",
            color: "danger",
            time: 8500,
            position: "top-right",
          });
        }, 1300);
        setTimeout(() => {
          vm.clearButtonLoading();
        }, 1300);
      }
    },
    finalizeCreditCardPayment(token) {
      console.log({ token: token });
      let vm = this;
      let requesPayload = {
        description: "TAX_NEW_CARD",
        method: "credit_card",
        email: vm.company.email,
        token: token,
        months: vm.timeSelected.value.toString(),
        upload_register_id: vm.popupAlertPayTaxContent.id,
      };
      vm.axios
        .post(vm.$store.state.filooServer + "payment/charge", requesPayload, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            if (
              response.data.status == "Transação negada" ||
              response.data.status == "Cartão inválido"
            ) {
              vm.clearButtonLoading();
              vm.$bvModal.hide("modal-payment-recharge");
              vm.$vs.notify({
                title: "Atenção!",
                text:
                  "Não foi possível realizar esta operação. A transão foi negada pela operadora, verique os dados digitados e tente novamente ou utilize outro cartão. Caso o problema persista por favor contacte o administrador do sistema.",
                color: "danger",
                time: 8500,
                position: "top-right",
              });
            } else {
              vm.clearButtonLoading();
              vm.$bvModal.hide("modal-payment-recharge");
              vm.showNotifySuccess("Operação realizada", "Pagamento realizado com sucesso.", 4000);
              vm.$router.push("/employee-payment-report");
            }
          }
        })
        .catch(function (error) {
          console.log({ error: error });
          vm.clearButtonLoading();
          vm.$bvModal.hide("modal-payment-recharge");
          vm.showNotifyError("Não foi possível realizar esta operação", 6000);
        });
    },
    initIUGU() {
      const vm = this;
      Iugu.setAccountID(vm.$store.state.iuguNotifyAccountId);
      Iugu.setup();
      Iugu.setTestMode(vm.$store.state.iuguTestMode);
      console.log({ iugu: Iugu });
    },

    async getAddressData(zipcode) {
      this.invalidFields.zipcode = false
      this.invalidFields.number = false
      this.invalidFields.street = false
      this.invalidFields.state = false
      this.invalidFields.city = false

      if (/^[0-9]{5}-[0-9]{3}$/.test(zipcode)) {
        const response = await this.getAddressByZipcode(zipcode)

        if (response && response.address) {
          this.company.address.street = response.address.street
          this.company.address.city = response.address.city
          this.company.address.state = response.address.state
          this.company.address.neighborhood = response.address.neighborhood
        }
      }
    },
    handleSearch(searching) {
      let vm = this;
      vm.searchCompanies = searching;
      vm.getEmployees();
    },
    changePagination() {
      const vm = this;
      vm.getEmployees();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleSort(key, active) {
      let vm = this;
      vm.sortBy = key;
      if (active === true) {
        vm.order = "desc";
      } else {
        vm.order = "asc";
      }
      vm.getEmployees();
    },
    getTaxCard() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "parameters/tax/boleto_charge_tax", {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.taxBankSlip = response.data;
          }
        })
        .catch(function (error) {
          console.log({ error: error });
        });
    },
    getTaxBankSlip() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "parameters/tax/card_charge_tax", {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.taxCard = response.data;
          }
        })
        .catch(function (error) {
          console.log({ error: error });
        });
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>
<style lang="scss" src="./employees-with-pending-fees.scss">
</style>
